module.exports = __webpack_public_path__ + "img/message-slash.99c4aede.svg";